import { render, staticRenderFns } from "./MainVirtualPos.vue?vue&type=template&id=1c6010a4"
import script from "./MainVirtualPos.vue?vue&type=script&lang=js"
export * from "./MainVirtualPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports